import type { ContractStatus } from '@weft/types';
import { CONTRACT_STATUSES, ContractStatusSchema } from '@weft/types';
import { useStateParams } from '../../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../../utils/params-formatting';

export function useContractStatusesParam() {
  return useStateParams<ContractStatus[]>([CONTRACT_STATUSES.Active], 'contractStatuses', serializeStringArrayParam, deserializeContractStatusArrayParam);
}

function deserializeContractStatusArrayParam(contractStatusesArrayStringified: string): ContractStatus[] | null {
  const statuses = contractStatusesArrayStringified.split(',');

  return statuses.map(status => {
    return ContractStatusSchema.parse(status);
  });
}